import * as React from "react";
const SvgFiRrInsertArrows = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-insert-arrows_svg__a)">
      <path
        fill="#062147"
        d="M.256 1.668A1 1 0 1 1 1.744.332l4.474 4.985A7 7 0 0 1 8 9.983v6.047l1.307-1.25a1 1 0 0 1 1.387 1.442l-2.301 2.212a1.987 1.987 0 0 1-2.798-.013l-2.288-2.2a1 1 0 0 1 1.387-1.441l1.307 1.256V9.983A5 5 0 0 0 4.73 6.652zM23 12a1 1 0 0 0-1 1v6c0 1.654-1.346 3-3 3H5c-1.654 0-3-1.346-3-3v-6a1 1 0 1 0-2 0v6c0 2.757 2.243 5 5 5h14c2.757 0 5-2.243 5-5v-6a1 1 0 0 0-1-1m-7.405 6.42a1.99 1.99 0 0 0 2.798.013l2.301-2.212a1 1 0 0 0-1.387-1.442L18 16.029V9.982c0-1.231.451-2.414 1.271-3.33l4.474-4.985A1 1 0 1 0 22.257.33l-4.475 4.986a7 7 0 0 0-1.781 4.664v6.053l-1.307-1.256a1 1 0 0 0-1.387 1.442z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-insert-arrows_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrInsertArrows;
